module.exports = __webpack_public_path__ + "fonts/dystopian-regular.7040b64b.woff2";